{
  "title": "Дашборд",
  "greeting": "Вітаємо, {{name}}!",
  "activeSchool": "Ви переглядаєте {{school}}.",
  "quickActions": {
    "title": "Швидкі дії",
    "description": "Дві дії, з яких починається школа.",
    "inviteMember": "Запросити учасника",
    "createClass": "Створити клас"
  },
  "myClasses": {
    "title": "Мої класи",
    "empty": "Ви ще не в жодному класі — приєднайтеся за кодом від учителя.",
    "join": "Приєднатися за кодом",
    "viewAll": "Усі класи"
  },
  "myChildren": {
    "title": "Мої діти",
    "empty": "З вами ще не пов'язано жодної дитини — зверніться до школи."
  },
  "toGrade": {
    "title": "Потребує перевірки",
    "description": "Роботи, які чекають на вас.",
    "submissions": "Домашні роботи",
    "attempts": "Спроби в тестах",
    "empty": "Наразі нічого перевіряти.",
    "openSubmissions": "Перевірити роботи",
    "openAttempts": "Перевірити спроби",
    "count_one": "{{count}} робота",
    "count_few": "{{count}} роботи",
    "count_many": "{{count}} робіт",
    "count_other": "{{count}} робіт"
  },
  "dueSoon": {
    "title": "Незабаром здавати",
    "description": "Домашні завдання й тести, які варто зробити.",
    "empty": "Найближчого тижня нічого здавати.",
    "due": "До {{date}}",
    "noDue": "Без терміну",
    "homework": "Домашнє завдання",
    "test": "Тест",
    "viewHomework": "Усі завдання",
    "viewTests": "Усі тести"
  },
  "childrenSummary": {
    "title": "Мої діти",
    "description": "Їхні останні домашні роботи.",
    "viewAll": "Переглянути все",
    "empty": "Робіт ще не здавали."
  },
  "glance": {
    "title": "Школа коротко",
    "teachers": "Вчителі",
    "pupils": "Учні",
    "classes": "Класи",
    "invitations": "Запрошення в очікуванні",
    "year": "Показано класи за {{name}}."
  }
}
